import React, { useState, useEffect } from 'react';
import EditableGoalTable from './EditableGoalTable';
import AdditionalPipelineTable from './AdditionalPipelineTable';


const AdditionalQualifiedPipelineNeeded = (props) => {
    const [goalValue, setGoalValue] = useState(props.initialGoal)

    const handleGoalChange = (newGoal) => {
       setGoalValue(newGoal)
       };

    return (
        <>
        <EditableGoalTable  
                      projectedMidpoint={props.projectedMidpoint}
                      initialGoal={props.initialGoal}
                      onGoalChange={handleGoalChange} />

                      <AdditionalPipelineTable data={props.data}
                            converted={goalValue}
                            gap={goalValue - props.projectedMidpoint}
                            cr1={props.convertedrowOne}
                         />
        </>
    )
        
    
}


export default AdditionalQualifiedPipelineNeeded